import { render, staticRenderFns } from "./ContentGameHistoryMobile.vue?vue&type=template&id=61f6a3b2&scoped=true&"
import script from "./ContentGameHistoryMobile.vue?vue&type=script&lang=js&"
export * from "./ContentGameHistoryMobile.vue?vue&type=script&lang=js&"
import style0 from "./ContentGameHistoryMobile.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ContentGameHistoryMobile.vue?vue&type=style&index=1&id=61f6a3b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f6a3b2",
  null
  
)

export default component.exports